// @flow
import type { TGridBreakpointName } from '@graphite/types';

const useDefaultDevice: () => TGridBreakpointName = () => 'desktop';

export default useDefaultDevice;
